﻿<template>

    <header class="header mb-app-header">
        <header_menu></header_menu>
    </header>

    <main class="mb-shell">
        <div class="mb-page">
            <nav class="mb-breadcrumb" aria-label="Breadcrumb">
                <a @click="go_home()">
                    <svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="home" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path fill="currentColor" d="M341.8 72.6C329.5 61.2 310.5 61.2 298.3 72.6L74.3 280.6C64.7 289.6 61.5 303.5 66.3 315.7C71.1 327.9 82.8 336 96 336L112 336L112 512C112 547.3 140.7 576 176 576L464 576C499.3 576 528 547.3 528 512L528 336L544 336C557.2 336 569 327.9 573.8 315.7C578.6 303.5 575.4 289.5 565.8 280.6L341.8 72.6zM304 384L336 384C362.5 384 384 405.5 384 432L384 528L256 528L256 432C256 405.5 277.5 384 304 384z"/></svg>
                    Home
                </a>
                <span class="mb-sep">/</span>
                <span class="mb-current">Manage Bookings</span>
            </nav>

            <div class="mb-page-header">
                <div>
                    <h1>Manage Bookings</h1>
                    <p class="mb-subtitle" v-if="account_information.name">
                        Account <strong>{{account_information.name}}</strong>
                    </p>
                </div>
                <div class="mb-stat" v-if="!loading_search">
                    <span class="mb-stat-value">{{Booking_Search?.bookings?.length ?? 0}}</span>
                    {{(Booking_Search?.bookings?.length ?? 0) === 1 ? 'booking' : 'bookings'}}
                </div>
            </div>

            <div class="hidden lg:block">
                <booking_table :hidden="loading_search" :bookings="Booking_Search?.bookings" @bookings_changed="download_bookings()" />
            </div>
            <div class="block lg:hidden">
                <booking_cards :hidden="loading_search" :bookings="Booking_Search?.bookings" @bookings_changed="download_bookings()" />
            </div>

            <div class="mb-card" v-if="loading_search" role="status" aria-live="polite">
                <div class="mb-loading-label">
                    <svg class="mb-spinner" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" aria-hidden="true">
                        <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="3" opacity="0.25" />
                        <path d="M22 12a10 10 0 0 0-10-10" stroke="currentColor" stroke-width="3" stroke-linecap="round" />
                    </svg>
                    Loading bookings…
                </div>
                <div class="mb-skeleton" aria-hidden="true">
                    <div class="mb-skeleton-row" v-for="n in 6" :key="n">
                        <span v-for="c in 8" :key="c"></span>
                    </div>
                </div>
            </div>

        </div>
    </main>

    <footer_item></footer_item>

</template>

<script lang="ts" src="./manage_bookings.ts"></script>